'use client';

import {useTranslations} from 'next-intl';
import {type FC, memo} from 'react';
import {StatIcon} from '@/components/atoms/StatIcon';
import type {FirstTimePeriodEntryModalReward} from './FirstTimePeriodEntryModal.types';

interface FirstTimePeriodEntryModalViewProps {
  reward: FirstTimePeriodEntryModalReward;
  onClose: () => void;
}

/**
 * @description Контент модалки по макету My7-2025-b2c и по образцу CelebrityShareSuccessModal.
 */
export const FirstTimePeriodEntryModalView: FC<FirstTimePeriodEntryModalViewProps> = memo(({reward, onClose}) => {
  const t = useTranslations('experiences.card');
  const hasCoins = reward.coins > 0;
  const hasPoe = reward.poe > 0;

  return (
    <>
      <div className="flex flex-col items-center gap-3 px-2 pt-1 md:gap-4 md:px-12 md:pt-0 mb-4 md:mb-6">
        <h2 className="text-center font-['inter'] text-[20px] font-bold leading-7 text-[#E9ECF0] md:text-[36px] md:leading-[44px]">
          {t('congratulations')}
        </h2>
      </div>

      <p className="max-w-[180px] mx-auto md:max-w-none mb-5 md:mb-8 text-center font-['inter'] text-[16px] font-medium leading-5 text-[rgba(233,236,240,0.8)] md:text-[20px] md:leading-normal">
        {t('first_period_entry_subtitle', {hours: 8})}
      </p>

      <div className="flex flex-col mb-7 md:mb-[52px]">
        <p className="mb-3 md:mb-4 text-center font-['inter'] text-[16px] font-medium leading-5 text-[rgba(233,236,240,0.8)] md:text-[20px] md:leading-normal">
          {t('you_earned')}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3">
          {hasCoins && (
            <div className="flex h-14 items-center gap-1.5 rounded-[60px] bg-[rgba(56,56,71,0.4)] pl-4 pr-6 py-3 md:h-[72px] md:gap-2 md:pl-5 md:pr-7 md:py-[15px] md:rounded-[80px]">
              <StatIcon type="coins" className="size-8 md:size-10" />
              <span className="font-['inter'] text-[28px] font-semibold leading-[1.16] text-[#E9ECF0] md:text-[36px] md:leading-[1.12]">
                {reward.coins}
              </span>
            </div>
          )}
          {hasPoe && (
            <div className="flex h-14 items-center gap-1.5 rounded-[60px] bg-[rgba(56,56,71,0.4)] pl-4 pr-6 py-3 md:h-[72px] md:gap-2 md:pl-5 md:pr-7 md:py-[15px] md:rounded-[80px]">
              <StatIcon type="fanTokens" className="size-8 md:size-10" />
              <span className="font-['inter'] text-[28px] font-semibold leading-[1.16] text-[#E9ECF0] md:text-[36px] md:leading-[1.12]">
                {reward.poe}
              </span>
            </div>
          )}
        </div>
      </div>

      <button
        type="button"
        onClick={onClose}
        className="flex h-12 w-full items-center justify-center rounded-[14px] bg-[#E9ECF0] font-montserrat text-base font-bold uppercase tracking-[0.32px] text-[#1E1E2A] transition-opacity hover:opacity-90 md:h-[60px] md:text-[19px] md:leading-[1.2]"
      >
        {t('ok')}
      </button>
    </>
  );
});

FirstTimePeriodEntryModalView.displayName = 'FirstTimePeriodEntryModalView';
